import httpClient from '@/http-client'

export const get = (id, Options = {}) => {
  return httpClient
    .get(`/api/homeworks/comment-public/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getComment = (id, Options = {}) => {
  return httpClient
    .get(`/api/homeworks/comment-public?homework_id=${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/homeworks/comment-public', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/homeworks/comment-public/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/homeworks/comment-public/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const download = (Options = {}) => {
  return httpClient
    .get('/api/files', { responseType: 'arraybuffer', ...Options })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, update, destroy, getComment, download }
